import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Solutions from "../pages/solutions/page";
import SolutionSceneDetail from "../pages/solutions/detail/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/products/detail/page";
import Cases from "../pages/cases/page";
import CaseDetail from "../pages/cases/detail/page";
import About from "../pages/about/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/solutions/detail/:subId",
    element: <SolutionSceneDetail />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/products/:id",
    element: <ProductDetail />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
